import axios from 'axios';

import cfac22 from '../../cfac22';

export default function checkProduct(uId, productId) {
  return new Promise((resolve, reject) => {
    Promise.resolve().
    then(() => {
      axios.
      get(

        `${cfac22('API_HOST_V2')}/checkout/product/${productId}`,
        {
          headers: { 'Full-Url': window.location.href }, withCredentials: true
        }
      ).
      then(async (result) => {
        // console.log("RESULT_CheckProduct: ", result);
        resolve(result.data);
      }).
      catch((error) => {
        //console.log("ERROR_CheckProduct: ", error);
        return reject(error);
      });
    }).
    catch((error) => {
      //console.log("ERROR_TOKEN:", error);
      reject(error);
    });
  });
}
